// Logo NULED — SVG extraído de nuled.mx
// viewBox: 0 0 245.417 58.032
// Usa currentColor para poder pintarlo blanco en header verde
// o verde petróleo en otros contextos.

type Props = { height?: number; color?: string };

export function Logo({ height = 36, color = 'currentColor' }: Props) {
  const width = Math.round(height * (245.417 / 58.032));

  return (
    <svg
      viewBox="0 0 245.417 58.032"
      width={width}
      height={height}
      preserveAspectRatio="xMinYMid meet"
      shapeRendering="geometricPrecision"
      role="img"
      aria-label="NULED"
      focusable="false"
      style={{ display: 'block', width, height, color, flexShrink: 0 }}
    >
      <title>NULED</title>
      <path d="M3.289,0,32.517,56.97l.126.247H36.6L7.244,0Z" transform="translate(1.483)" fill="currentColor" />
      <rect width="3.517" height="57.216" transform="translate(0 0)" fill="currentColor" />
      <rect width="3.519" height="57.216" transform="translate(39.336 0)" fill="currentColor" />
      <path d="M77.875,0V35.545c0,12.339-6.013,19.134-16.93,19.134s-16.93-6.795-16.93-19.134V0H40.5V33.995c0,15.726,7.071,24.037,20.447,24.037s20.447-8.311,20.447-24.037V0Z" transform="translate(18.264 -0.001)" fill="currentColor" />
      <path d="M83.163,53.863V0H79.646V57.216h32V53.863Z" transform="translate(35.919 -0.001)" fill="currentColor" />
      <path d="M111.231,53.863V29.143h27.421V25.789H111.231V3.354h28.155V0H107.712V57.216h32.326V53.863Z" transform="translate(48.576 -0.001)" fill="currentColor" />
      <path d="M152,0H138.649V57.216H152c19.343,0,30.893-10.694,30.893-28.607S171.34,0,152,0m27.212,28.609c0,16.521-9.693,25.254-28.029,25.254h-9.013V3.355h9.013c18.336,0,28.029,8.732,28.029,25.254" transform="translate(62.528 -0.001)" fill="currentColor" />
    </svg>
  );
}
